import SearchIcon from '@/components/icons/SearchIcon.vue'
import GettingStartIcon from '@/components/icons/GettingStartIcon.vue'

import { NAVIGATION_ACTIONS } from '@/constants/navigationActions'
import { ROUTES } from '@/constants/routes'

import { ROUTER_PARAMS_NAMES } from '@/constants/routerParamsNames'

const GETTING_START = {
    id: 3,
    name: 'Getting Started',
    routeName: ROUTES.gettingStart,
    paramsNames: [ROUTER_PARAMS_NAMES.workspace],
    icon: () => GettingStartIcon,
}

const SEARCH = {
    id: 1,
    action: NAVIGATION_ACTIONS.search,
    name: 'Search',
    tippy: 'Search',
    icon: () => SearchIcon,
}

const TOP_MENU_ACCOUNT_FOR_OWNER = [
    SEARCH,
]

const TOP_MENU_ACCOUNT_FOR_MANAGER = [
    SEARCH,
    GETTING_START,
]

export {
    SEARCH,
    GETTING_START,
    TOP_MENU_ACCOUNT_FOR_OWNER,
    TOP_MENU_ACCOUNT_FOR_MANAGER,
}
